var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack505({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.13,11.31l1.09-.11a1,1,0,0,0,.28.58.76.76,0,0,0,1.12-.06,1.3,1.3,0,0,0,.23-.84,1.15,1.15,0,0,0-.23-.79A.79.79,0,0,0,8,9.83a1.12,1.12,0,0,0-.85.41l-.89-.13.57-3h2.9v1H7.66l-.17,1a1.68,1.68,0,0,1,2,.35A1.93,1.93,0,0,1,10,10.86a2,2,0,0,1-.41,1.26A1.81,1.81,0,0,1,8,12.88a1.88,1.88,0,0,1-1.29-.43A1.77,1.77,0,0,1,6.13,11.31Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack505);
export default __webpack_public_path__ + "static/media/Symbolpack_5_05.54cb26fa8c300dae106c596061ef4cf8.svg";
export { ForwardRef as ReactComponent };